// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"339":"5f87450e","429":"03c56121","494":"fa2efdbd"}[chunkId] + ".chunk.css";
};